var React = require('react');

function DC (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"counties","key":0},React.createElement("path",{"id":"county-11001","className":"county feature","d":"M780.444 270.733l-1.497-1.586-.429-.43 1.537-.917 1.585 1.084z","vectorEffect":"non-scaling-stroke","fill":"inherit","stroke":"inherit","strokeWidth":"inherit"},React.createElement("title",null,"District of Columbia"))),React.createElement("path",{"id":"counties-mesh","className":"counties mesh","d":"M778.518 268.717l1.537-.917 1.585 1.084-1.196 1.849-1.497-1.586-.429-.43","vectorEffect":"non-scaling-stroke","fill":"inherit","stroke":"inherit","strokeWidth":"inherit","key":1})]);
}

DC.defaultProps = {"version":"1.2","id":"root","viewBox":"778.5183009001696 267.8001688342214 3.122169941955235 2.9327009994242417"};

module.exports = DC;

DC.default = DC;
